export function AuroraBackdrop() {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 overflow-hidden"
      style={{
        background:
          'linear-gradient(135deg, rgb(var(--indigo-100) / 0.7) 0%, rgb(var(--surface)) 55%, rgb(var(--indigo-50) / 0.9) 100%)',
      }}
    >
      <div
        className="aurora-blob absolute -left-20 -top-10 h-96 w-96 rounded-full opacity-60 blur-[60px]"
        style={{
          background:
            'radial-gradient(closest-side, rgb(var(--indigo-400) / 0.55), transparent 70%)',
          animation: 'aurora-drift-1 14s ease-in-out infinite',
        }}
      />
      <div
        className="aurora-blob absolute -right-16 top-[28%] h-80 w-80 rounded-full opacity-55 blur-[60px]"
        style={{
          background: 'radial-gradient(closest-side, rgb(var(--info) / 0.5), transparent 70%)',
          animation: 'aurora-drift-2 18s ease-in-out infinite',
        }}
      />
      <div
        className="aurora-blob absolute -bottom-16 left-[28%] h-72 w-72 rounded-full opacity-55 blur-[60px]"
        style={{
          background:
            'radial-gradient(closest-side, rgb(var(--indigo-500) / 0.45), transparent 70%)',
          animation: 'aurora-drift-3 16s ease-in-out infinite',
        }}
      />
    </div>
  );
}
